<template>
    <paper class="performance-dispatch-inroad-wrapper">
        <el-row>
            <el-col :span="span">
                <dispatchNo-list
                    ref="dispatchNoList"
                    @getColSpan="setColSpan"
                    @setSelectDispatchNoData="getSelectDispatchNoData"
                ></dispatchNo-list>
            </el-col>
            <el-col :span="24 - span">
                <right-section :mapAndTabsData="selectData"></right-section>
            </el-col>
        </el-row>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import DispatchNoList from './compontents/DispatchNoList.vue';
import RightSection from './compontents/RightSection.vue';

export default {
    name: 'dispatchInRoadMonitor',
    components: {
        paper,
        DispatchNoList,
        RightSection
    },
    data () {
        return {
            span: 4,
            selectData: {}
        };
    },
    methods: {
        setColSpan (val) {
            this.span = val;
        },
        getSelectDispatchNoData (val) {
            this.selectData = val;
        },
        viewTrack () {
            const dispatchNo = this.$route.query.dispatchNo;
            this.$nextTick(() => {
                // 路由带参时，查询对应发车单轨迹
                if (dispatchNo) {
                    this.$refs.dispatchNoList.search(dispatchNo);
                }
            });
        }
    },
    mounted () {
        this.viewTrack();
    },
    beforeRouteEnter (to, from, next) {
        const routerInfo = [
            '/otp/dispatch-order',
            '/performance/dispatch-order',
            '/performance/dispatch-info-detail',
            '/performance/vehicle-transit-warning',
            '/performance/dispatch-order-detail'
        ];
        if (routerInfo.includes(from.path)) {
            next(vm => {
                vm.viewTrack();
            });
        } else {
            next();
        }
    }
};
</script>
<style lang="less" scoped>
.performance-dispatch-inroad-wrapper {
    padding: 0;
}
.el-row {
    height: 100%;
    .el-col {
        height: 100%;
    }
    .el-col-1 {
        width: 2.16667% !important;
        transition: width 0.5s;
    }
    .el-col-4 {
        transition: width 0.5s;
    }
    .el-col-20 {
        transition: width 0.5s;
    }
    .el-col-23 {
        width: 97.83333% !important;
        transition: width 0.5s;
    }
}
</style>
